(() => {
  /*============================================================================
    Product template
  ==============================================================================*/
  var ProductTemplate = function () {
    var container;
    var sectionType;

    function ProductTemplate(element) {
      container = element;
      _classCallCheck(this, ProductTemplate);
      sectionType = container.dataset.sectionType;

      _initThumbCarousel();

      _attachListeners();

      _initAvailableStates();
    }

    function _initThumbCarousel() {
      const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
      const isMobile = windowWidth < theme.sizes.small;
      var checked = container.querySelector('input[name="options[Color]"]:checked');
      if (checked) {
        checked = checked.value.toLowerCase().replaceAll(' ', '-');
      }
      var groupId = container.querySelector('.product-form input[name="productId"]').value;
      if (container.getAttribute('data-tall-layout') !== 'true' || isMobile) {

        let thumbsHolder = container.querySelector('[data-product-thumbs]');
        if (thumbsHolder) {
          _waitForElement('.thumbs-holder').then((elem) => {
            showVariantImages(elem, checked, groupId);
          });
        }
      } else {
        showVariantImages(container, checked, groupId);
      }
    }

    function _updateAvailableStates(form) {
      form.querySelectorAll('.product__selectors .selector-wrapper span').forEach(element => {
        element.classList.remove('soldout');
        element.classList.remove('unavailable');
      });

      var selectors = form.querySelectorAll('.product__selectors .selector-wrapper');

      if(selectors) {
        var numOptions = form.querySelectorAll('.product__selectors .selector-wrapper').length;
        if( numOptions == 1 ) {
          form.querySelectorAll('.product__selectors .selector-wrapper input[type="radio"]').forEach(radio => {
            form.querySelectorAll('.product__form__select--info option').forEach(selectOption => {
              let optionValue = selectOption.innerHTML.trim();

              if (optionValue == radio.value && selectOption.disabled) {
                radio.parentElement.classList.add('soldout');
              }
            });
          });
        } else {
          form.querySelectorAll('.product__selectors .selector-wrapper').forEach(option => {
            // The first selected option
            let selectPosition = option.dataset.selectPosition;
            let selectedRadio = option.querySelector('input[type="radio"]:checked');
            let selectedValue = selectedRadio.value.replaceAll('"', '&quot;');
            
            form.querySelectorAll('.product__selectors .selector-wrapper:not([data-select-position="' + selectPosition + '"]) input[type="radio"]').forEach(radio => {
              let option2 = radio.value.replaceAll('"', '&quot;');
              let composeOption = selectedValue + ' / ' + option2;
              let composeOption2 = option2 + ' / ' + selectedValue;
    
              let found = false;
    
              form.querySelectorAll('.product__form__select--info option').forEach(selectOption => {
                let optionValue = selectOption.innerHTML.trim().replaceAll('"', '&quot;');
                if (optionValue == composeOption || optionValue == composeOption2) {
                  found = true;
                }
              });
              if (!found) {
                radio.parentElement.classList.add('unavailable');
              }
            });
  
            form.querySelectorAll('.product__form__select--info option').forEach(selectOption => {
              let arrayValues = selectOption.innerHTML.split(' / ');
              var arrayOption = arrayValues[selectPosition - 1];

              // If the option text contains the name of the selected value and it´s disabled then mark it as soldout
              if (arrayOption.trim().replaceAll('"', '&quot;') === selectedValue && selectOption.disabled) {
                var option1 = arrayValues[0].trim().replaceAll('"', '&quot;');
                var option2 = null;
                var option3 = null;
                
                if (arrayValues.length > 2) {
                  option2 = arrayValues[1]?.trim().replaceAll('"', '&quot;');
                  option3 = arrayValues[2]?.trim().replaceAll('"', '&quot;')
                } else {
                  option2 = arrayValues[1]?.trim().replaceAll('"', '&quot;');
                }

                form.querySelectorAll('.product__selectors .selector-wrapper:not([data-select-position="' + selectPosition + '"])').forEach(sibling => {
                  //var element = sibling.querySelector(`input[type="radio"][value="${option1.replace(/"/g, '\\"')}"]`);
                  var element = sibling.querySelector(`input[type="radio"][value="${option1.replaceAll('"', "&quot;")}"]`);
                  if (element) element.parentElement.classList.add('soldout');
    
                  if (option2) {
                    //element = sibling.querySelector(`input[type="radio"][value="${option2.replace(/"/g, '\\"')}"]`);
                    element = sibling.querySelector(`input[type="radio"][value="${option2.replaceAll('"', "&quot;")}"]`);
                    if (element) element.parentElement.classList.add('soldout');
                  }
    
                  if (option3) {
                    //element = sibling.querySelector(`input[type="radio"][value="${option3.replace(/"/g, '\\"')}"]`);
                    element = sibling.querySelector(`input[type="radio"][value="${option3.replaceAll('"', "&quot;")}"]`);
                    if (element) element.parentElement.classList.add('soldout');
                  }
                });
              }
            });
          });
        }
      }
    }

    function _initAvailableStates() {
      container.querySelectorAll('.product-form').forEach(form => {
        _updateAvailableStates(form);
      });
    }

    function showVariantImages(elem, value, productId) {
      if (container.classList.contains('product--no-color') !== true) {
        let thumbs = elem.querySelectorAll('.thumb');
        if (thumbs) {
          thumbs.forEach(thumb => {
            thumb.classList.add('hidden');
            var link = thumb.querySelector('.thumb__link');
            var alt = thumb.querySelector('img').getAttribute('alt');
            var groupId = link.dataset.groupId;

            if (alt) {
              alt = alt.toLowerCase().replaceAll(' ', '-');
              if (alt.includes(value) && groupId == productId) {
                thumb.classList.remove('hidden');
              }
            }
          });
          elem.querySelector('.thumb:not(.hidden) .thumb__link')?.click();
        }

        // hide all the images when layout is stacked
        let slides = elem.querySelectorAll('.product__slide');
        if (slides) {
          slides.forEach(slide => {
            slide.classList.add('hidden');
            var option = slide.dataset.option;
            var groupId = slide.dataset.groupId;

            if (option) {
              option = option.toLowerCase().replaceAll(' ', '-');
              if (option.includes(value) && groupId == productId) {
                slide.classList.remove('hidden');
                slide.classList.remove('product__slide--non-critical');
              }
            }
          });
        }
      } else {
        elem.querySelectorAll('.product__slide').forEach((slide) => {
          slide.classList.remove('hidden');
          slide.classList.remove('product__slide--non-critical');
        });
      }

      /**
       * Build thumbnails on desktop.
       * @author Benjamin <benjamin@7q81.co>
       */
      ((elem) => {
        // This works only in stacked mode.
        if (!document.querySelector('.product__wrapper--stacked')) {
          return;
        }

        const photosHolder = document.querySelector('.product__wrapper--stacked .product__slider-container');

        if (!photosHolder) {
          return;
        }

        const scrollToSlide = (slide) => {
          const announcementHeight = document.getElementById('shopify-section-announcement')?.clientHeight || 0;
          const headerHeight = document.getElementById('shopify-section-header')?.clientHeight || 0;

          var scroller = document.querySelector('.product-images__container');
          scroller.scrollTo({
            top: slide.offsetTop + (announcementHeight + headerHeight - 8),
            left: 0,
            behavior: 'smooth',
          });
        };

        const createAndAppendThumbnail = (slide) => {
          const thumbSrc = slide.dataset.thumb;

          if (!thumbSrc) {
            return null;
          }

          const wrapper = document.createElement('div');
          const link = document.createElement('a');
          const image = document.createElement('img');

          image.src = thumbSrc;
          image.loading = 'lazy';
          image.classList.add('thumb__link__image');

          link.classList.add('thumb__link', 'thumb__link--image');

          link.addEventListener('click', (evt) => {
            evt.preventDefault();
            scrollToSlide(slide);
          });

          wrapper.classList.add('thumb');

          link.appendChild(image);
          wrapper.appendChild(link);

          thumbsHolder.appendChild(wrapper);
        };

        // Thumbs holder
        let thumbsHolder = document.querySelector('.product__thumbs.product__thumbs--stacked');

        if (!thumbsHolder) {
          thumbsHolder = document.createElement('div');
          thumbsHolder.classList.add('product__thumbs', 'product__thumbs--stacked');
          photosHolder.insertBefore(thumbsHolder, photosHolder.firstChild);
        }

        elem.querySelectorAll('.product__slide:not(.hidden)').forEach((slide) => {
          createAndAppendThumbnail(slide);
        });

      })(elem);
    }

    function variantSelected() {
      const selected = this;
      const selectedPosition = selected.closest('.selector-wrapper').dataset.selectPosition;
      const productId = selected.closest('form').querySelector('input[name="productId"]').value;
      const preorderMessageNode = document.querySelector('.product-form__preorder-message');

      /**
       * Dynamic Yield option change event
       */
      DY.API('event', {
        name: 'Change Attribute',
        properties: {
          dyType: 'change-attr-v1',
          attributeType: selected.name.replace('options[', '').replace(/]$/, ''),
          attributeValue: selected.value,
        },
      });

      if (selected.getAttribute('name') == 'options[Color]') {
        let value = selected.value.toLowerCase().replaceAll(' ', '-');

        // let elem = document.querySelector('.thumbs-holder');
        // showVariantImages(elem, value, productId);
        const windowWidth = window.innerWidth || document.documentElement.clientWidth || document.body.clientWidth;
        const isMobile = windowWidth < theme.sizes.small;

        if (isMobile && container.getAttribute('data-tall-layout') !== 'true') {
          let thumbsHolder = container.querySelector('[data-product-thumbs]');
          if (thumbsHolder) {
            let elem = document.querySelector('.thumbs-holder');
            showVariantImages(elem, value, productId);
          }
        } else {
          showVariantImages(container, value, productId);
        }
      }

      let value = selected.value;

      // Clear all values
      selected.closest('.selector-wrapper').querySelectorAll('.radio__fieldset').forEach(field => {
        field.querySelector('.radio__legend__label--current').innerHTML = '';
        preorderMessageNode.textContent = '';
      });

      // Set the actual value in the corresponding fieldset
      selected.closest('.radio__fieldset').querySelector('.radio__legend__label--current').innerHTML = value;

      // Let's find the variant selected in the master select
      var selectedOption = '';
      var selectedVariantName = '';
      selected.closest('.product__selectors').querySelectorAll('input[type="radio"]:not(.optional-product__radio):checked').forEach(option => {
        if (selectedOption == '') {
          selectedOption = option.value;
        } else {
          selectedOption = selectedOption + ' / ' + option.value;
        }
      });
      selectedVariantName = selectedOption;
      selectedOption = selectedOption.replaceAll('"', '&quot;');

      let option = selected.closest('.product-form').querySelector('select.product__form__select--info option[data-value="' + selectedOption + '"]');

      if (option && option.dataset.showPreorder) {
        preorderMessageNode.textContent = option.dataset.preorderMessage;
      }

      if (option) {
        let bundleImage = option.dataset.bundleImage;
        let bundleLink = option.dataset.bundleLink;
        let bundleTitle = option.dataset.bundleTitle;
        let bundleText = option.dataset.bundleText;

        if(bundleImage && bundleLink) {
          let bundleContainer = document.querySelector('.product__bundle-box-container');
          if(bundleContainer) {
            bundleContainer.querySelector('img').src = bundleImage;
            bundleContainer.querySelector('a').href = bundleLink;
          } else {
            let html = '<div class="product__bundle-box-container product__bundle-box-container--two-columns">' + 
              '<div class="product__bundle-box-image">' +
                 '<img src="' + bundleImage + '" />' + 
              '</div>' +
              '<div class="product__bundle-box-content">' + 
                '<h3 class="product__bundle-box-pretitle">buy together</h3>';
            if(bundleTitle) html += '<h4 class="product__bundle-box-title small">' + bundleTitle + '</h4>';
            if(bundleText) html += '<div class="product__bundle-box-text small">' + bundleText + '</div>';
            if(bundleLink) html += '<a href="' + bundleLink + '" class="product__bundle-box-link">Bundle + Save</a>';
            html += '</div>' +
              '</div>';
            document.querySelector('.product__bundle-box-wrapper').innerHTML = html;
          }
        } else {
          document.querySelector('.product__bundle-box-wrapper').innerHTML = '';
        }
      }

      let form = selected.closest('.product-form');
      _updateAvailableStates(form, value, selectedPosition);

      // If it's a bundle then populate the final selection and update the price
      if (document.querySelector('[data-bundle-container]')) {
        let formIndex = form.closest('.bundle__product-container').dataset.index;

        // Search the value in the master select
        let selectedVariantImage;
        let selectedVariantTitle;
        let selectedVariantPrice;
        let selectedAvailability = true;
        if (option) {
          selectedVariantImage = option.dataset.image;
          selectedVariantTitle = option.dataset.title;
          selectedVariantPrice = option.dataset.price;
          if (option.hasAttribute('disabled')) {
            selectedAvailability = false;
          }
        }

        // If the variant selected is the first
        if (selected.closest('.product__selectors').querySelector('#optional-id')) {
          //Let's select the corresponding option of the optional product, same color and same size of the main product
          const $select = document.getElementById('optional-id');
          const $options = Array.from($select.options);
          const optionToSelect = $options.find(item => item.text === selectedVariantName);
          if (optionToSelect) {
            optionToSelect.selected = true;
          }
        }

        let bundleFinalCell = document.querySelector('.product__bundle-variant[data-index="' + formIndex + '"]');
        bundleFinalCell.querySelector('.product__bundle-variant-image').setAttribute('src', selectedVariantImage);
        bundleFinalCell.querySelector('h3').innerHTML = selectedVariantTitle;
        bundleFinalCell.setAttribute('data-price', selectedVariantPrice);
        bundleFinalCell.setAttribute('data-availability', selectedAvailability);

        // Get all the bundles individual item prices and sum it up
        var bundleFinalPrice = 0;
        var variantUnavailable = false;
        document.querySelectorAll('.product__bundle-variant').forEach(variant => {
          if (variant.dataset.price) {
            bundleFinalPrice = parseInt(bundleFinalPrice) + parseInt(variant.dataset.price);
          }
          if (variant.dataset.availability && variant.dataset.availability === "false") {
            variantUnavailable = true;
          }
        });

        let button = selected.closest('.bundle__form').querySelector('.product__bundle__submit__add');
        let buttonText = button.querySelector('[data-add-to-cart-text]');
        if (variantUnavailable) {
          //disable add to cart and change the text
          button.setAttribute('disabled', '');
          buttonText.innerHTML = window.theme.strings.soldOut;
        } else {
          button.removeAttribute('disabled');
          buttonText.innerHTML = window.theme.strings.addToCart;
        }

        var optional_selected = document.querySelector('input[name="optional"]:checked').value;
        if (optional_selected == 1) {
          var optional_price = document.querySelector('input[name="optional-price"]').value;
          bundleFinalPrice = bundleFinalPrice + parseInt(optional_price);
        }

        //let's find ig the additional product is selected and get the price and sum it up
        bundleFinalPrice = themeVendor.themeCurrency.formatMoney(bundleFinalPrice, theme.moneyFormat);
        document.querySelector('[data-product-price]').innerHTML = bundleFinalPrice;
      }
    }

    function optionalSelected() {
      const value = this.value;

      if (value == 1) {
        // We need to get the price and sum with the actual price
        var price = this.closest('.optional-product__fieldset').querySelector('input[name="optional-price"]').value;

        var bundleFinalPrice = 0;
        document.querySelectorAll('.product__bundle-variant').forEach(variant => {
          if (variant.dataset.price) {
            bundleFinalPrice = parseInt(bundleFinalPrice) + parseInt(variant.dataset.price);
          }
        });

        //let's find ig the additional product is selected and get the price and sum it up
        bundleFinalPrice = bundleFinalPrice + parseInt(price);
        bundleFinalPrice = themeVendor.themeCurrency.formatMoney(bundleFinalPrice, theme.moneyFormat);
        document.querySelector('[data-product-price]').innerHTML = bundleFinalPrice;
      } else {
        // if deselect, then we need to adjust the prie to only the sum of the selected variants
        var bundleFinalPrice = 0;
        document.querySelectorAll('.product__bundle-variant').forEach(variant => {
          if (variant.dataset.price) {
            bundleFinalPrice = parseInt(bundleFinalPrice) + parseInt(variant.dataset.price);
          }
        });

        bundleFinalPrice = themeVendor.themeCurrency.formatMoney(bundleFinalPrice, theme.moneyFormat);
        document.querySelector('[data-product-price]').innerHTML = bundleFinalPrice;
      }
    }

    function _attachListeners() {
      container.querySelectorAll('.product__selectors input[type="radio"]:not(.optional-product__radio)').forEach(radio => {
        radio.addEventListener('change', variantSelected);
      });

      /* Update the Shop Pay form below the price */
      container.querySelector('.product-form input[name="id"]').addEventListener('change', function () {
        var value = this.value;
        var shopPayFormVariantId = container.querySelector('.shop-pay-terms input[name="id"]');
        if (shopPayFormVariantId) {
          shopPayFormVariantId.value = value;
          let form = shopPayFormVariantId.closest('form');
          let e = new Event("change");
          form.dispatchEvent(e);

          // Intelligems
          const productPrice = document.querySelector('.product__price__wrap .product__price .product__price--strike');
          const productSale = document.querySelector('.product__price__wrap .product__price .product__price--sale');
          const productNotSale = document.querySelector('.product__price__wrap .product__price .product__price--not-sale');

          if (productPrice) {
            productPrice.setAttribute('data-variant-id', value);
          }

          if (productSale) {
            productSale.setAttribute('data-variant-id', value);
          }

          if (productNotSale) {
            productNotSale.setAttribute('data-variant-id', value);
          }
          // End Intelligems
        }
      });

      window.addEventListener('resize', _initThumbCarousel);

      if (sectionType === 'product-bundle') {
        container.querySelector('.product__bundle__submit__add').addEventListener('click', function () {
          var items = [];
          container.querySelectorAll('.product-form').forEach(form => {
            let variantId = form.querySelector('input[name="id"]').value;
            items.push({ 'id': variantId, 'quantity': 1 });
          });

          let optional_product = container.querySelector('input[name="optional"]:checked');
          if (optional_product) {
            optional_product = optional_product.value;
            if (optional_product == 1) {
              let optional_id = container.querySelector('select[name="optional-id"]').value;
              if (optional_id) {
                items.push({ 'id': optional_id, 'quantity': 1 });
              }
            }
          }

          const data = { 'items': items };
          window.cart.addToCart(JSON.stringify(data));
        });

        container.querySelectorAll('input[name="optional"]').forEach(radio => {
          radio.addEventListener('change', optionalSelected);
        })
      }
    }

    _createClass(ProductTemplate, [{
      key: "onUnload",
      value: function onUnload() {

      }
    }]);

    return ProductTemplate;
  }();

  window.sections.register('product', ProductTemplate);
  window.sections.register('product-bundle', ProductTemplate);
})();

// Top Sheet
(() => {
  const container = document.querySelector('[data-section-type="product"]');
  const topSheetFieldset = document.querySelector('fieldset.optional-product__fieldset--top-sheet');

  if (!container || !topSheetFieldset) {
    return;
  }

  const mainPriceNode = container.querySelector('[data-product-price]');

  function setSoldOut() {
    topSheetFieldset.form.optional.value = '0';
    topSheetFieldset.querySelector('.radio__button--optional1').classList.add('soldout');
  }

  function removeSoldOut() {
    topSheetFieldset.querySelector('.radio__button--optional1').classList.remove('soldout');
  }

  function handleVariantChange(evt) {
    if (!evt.detail.variant.available) {
      setSoldOut();
      return;
    }

    const option1 = (evt.detail.variant.option1 || '').replace('"', '\"');
    const option2 = (evt.detail.variant.option2 || '').replace('"', '\"');
    const option3 = (evt.detail.variant.option3 || '').replace('"', '\"');  

    let selectedOption = document.querySelector(`.optional-product__options option[data-option1="${option1}"][data-option2="${option2}"][data-option3="${option3}"]`);

    if (!selectedOption) {
      selectedOption = document.querySelector(`.optional-product__options option[data-option1="${option1}"][data-option2="${option2}"]`);
    }

    if (!selectedOption) {
      selectedOption = document.querySelector(`.optional-product__options option[data-option1="White"][data-option2="${option2}"]`);
    }

    if (!selectedOption) {
      selectedOption = document.querySelector(`.optional-product__options option[data-option1="${option1}"]`);
    }

    if (!selectedOption || selectedOption.dataset.available === 'false') {
      setSoldOut();
      return;
    }

    removeSoldOut();

    topSheetFieldset.dataset.originalPrice = (parseFloat(evt.detail.variant.price, 10) / 100).toFixed(2);
    topSheetFieldset.dataset.plusPrice = selectedOption.dataset.price;
    topSheetFieldset.dataset.variantId = selectedOption.value;

    resolveTopSheetPrice();
  }

  function resolveTopSheetPrice(evt) {
    if (evt && evt.target.closest('.radio__button').classList.contains('soldout')) {
      evt.preventDefault();

      topSheetFieldset.form.optional.value = '0';

      return false;
    }

    const originalPrice = parseFloat(topSheetFieldset.dataset.originalPrice);
    const topSheetPlusPrice = parseFloat(topSheetFieldset.dataset.plusPrice || 0);

    if (topSheetFieldset.form.optional.value === '1') {
      mainPriceNode.textContent = `\$${(originalPrice + topSheetPlusPrice).toFixed(2)}`;
    } else {
      mainPriceNode.textContent = `\$${originalPrice.toFixed(2)}`;
    }
  }

  function hijackAddToCart(evt) {
    evt.preventDefault();
    evt.stopPropagation();

    const button = evt.target.closest('[data-add-to-cart]') || evt.target;
    const data = { 'items': [{ 'id': topSheetFieldset.form.id.value, 'quantity': topSheetFieldset.form.querySelector('.quantity__input')?.value || '1' }] };

    const topSheetVariantId = topSheetFieldset.dataset.variantId;

    if (topSheetFieldset.form.optional.value === '1') {
      data.items.push({ 'id': topSheetVariantId, quantity: '1' });
      window.cart.addToCart(JSON.stringify(data), null, button);
    } else {
      window.cart.addToCart(JSON.stringify(data), null, button);
    }
  }

  const submitButton = topSheetFieldset.form.querySelector('.product__submit__add');
  const submitButtonClone = submitButton.cloneNode(true);

  submitButtonClone.addEventListener('click', hijackAddToCart);

  submitButton.replaceWith(submitButtonClone);

  topSheetFieldset.querySelectorAll('.optional-product__radio').forEach((radio) => {
    radio.addEventListener('click', resolveTopSheetPrice);
  });

  container.addEventListener('theme:variant:change', handleVariantChange);
})();

// DY Events
(() => {
  if (document.querySelector('.product__price--sale')) {
    DY.API('event', {
      name: 'Sale/Clearance Visit',
      properties: {}
    });
  }
})();

// Bundle
(() => {
  const handleVariantChange = (evt) => {
    const container = evt.target.closest('div[data-bundle-container]');
    const titleIconCircle = container.querySelector('.bundle__title svg circle');
    const titleIconPath = container.querySelector('.bundle__title svg path');

    titleIconCircle.style.stroke = '#343230';
    titleIconPath.style.stroke = '#343230';
  }

  const toggleDrawerHeight = (evt) => {
    evt.preventDefault();

    const container = evt.target.closest('div[data-bundle-container]');
    const title = container.querySelector('.bundle__title-wrapper');
    const icon = container.querySelector('.bundle__title-drawer__icon svg');

    if (container.dataset.open === 'true') {
      container.style.height = `${title.clientHeight}px`;
      container.dataset.open = 'false';
    } else {
      container.style.height = `${container.dataset.height}px`;
      container.dataset.open = 'true';
    }
  };

  document.querySelectorAll('div[data-bundle-container]').forEach((node) => {
    node.dataset.height = node.clientHeight;
    node.dataset.open = 'true';
    node.style.height = `${node.clientHeight}px`;
  });

  document.querySelectorAll('.bundle__title-wrapper').forEach((node) => {
    node.addEventListener('click', toggleDrawerHeight);
  });

  document.querySelectorAll('div[data-bundle-container] .swatch__button:not(.soldout)').forEach((node) => {
    node.addEventListener('click', handleVariantChange);
  });
})();